import "core-js/modules/es.object.keys.js";
var LSMegaMenu = {
  initialize: function initialize() {
    if (LSUtils.isSamsung()) {
      $('.mega-menu-container').remove();
    }
    this.bind();
  },
  bind: function bind() {
    var $headerMenuItem = $('[data-mega-menu-id]');
    $headerMenuItem.bind('click', function (e) {
      var preventReopen = false;
      if ($(this).hasClass('active')) preventReopen = true;
      $('.mega-menu-container-showing a').attr('tabindex', '-1');
      $('.mega-menu-container-showing').removeClass('mega-menu-container-showing');
      if (!preventReopen) $('#' + $(this).attr('data-mega-menu-id')).addClass('mega-menu-container-showing');
      if (!preventReopen) $('.mega-menu-container-showing a').attr('tabindex', '0');
      $('.active').removeClass('active');
      if (!preventReopen) $(this).addClass('active');
      $('.header-menu-item-hover').removeClass('header-menu-item-hover');
      if (!preventReopen) $('.header-menu-item[data-mega-menu-id="' + $(this).attr('data-mega-menu-id') + '"]').addClass('header-menu-item-hover');
      return false;
    });
    $('body').bind('click', function () {
      $('#container-header .active').removeClass('active');
      $('.mega-menu-container-showing').removeClass('mega-menu-container-showing');
    });
    $('.mega-menu-close').bind('click', function () {
      $('.mega-menu-container-showing').removeClass('mega-menu-container-showing');
    });
    $('.header-menu-item', $('#mobile-mega-menu-container')).bind('click', function () {
      $('.hamburger').removeClass('is-active');
    });
    $('.mobile-header-menu-item').bind('click', function (ev) {
      if ($(this).attr('data-menuItem-link')) {
        $('.hamburger').trigger('click');
        location.href = $(this).attr('data-menuItem-link');
        return true;
      }
    });
    var self = this;
    $('.hamburger').bind('click', function () {
      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
        self.closeSlide();
      } else {
        $(this).addClass('is-active');
        self.openSlide();
      }
      return false;
    });
    $('.button-sign-in').bind('click', function () {
      self.openSignIn();
      return false;
    });
    $('.button-search').bind('click', function () {
      window.location.href = LSUtils.url() + "/company/search/";
      return false;
    });
    $('.button-learn').bind('click', function () {
      window.location.href = LSUtils.url() + "/blog/";
      return false;
    });
  },
  openSlide: function openSlide() {
    var $sliderMain = $('#container-main');
    var $sliderHeader = $('#container-header');
    var $sliderCover = $('#mobile-mega-menu-cover');
    $sliderMain.addClass('is-open' + (LSUtils.isSamsung() ? '-samsung' : ''));
    $sliderHeader.addClass('is-open' + (LSUtils.isSamsung() ? '-samsung' : ''));
    $sliderCover.addClass('is-open' + (LSUtils.isSamsung() ? '-samsung' : ''));
  },
  closeSlide: function closeSlide() {
    var $sliderMain = $('#container-main');
    var $sliderHeader = $('#container-header');
    var $sliderCover = $('#mobile-mega-menu-cover');
    $sliderMain.removeClass('is-open' + (LSUtils.isSamsung() ? '-samsung' : ''));
    $sliderHeader.removeClass('is-open' + (LSUtils.isSamsung() ? '-samsung' : ''));
    $sliderCover.removeClass('is-open' + (LSUtils.isSamsung() ? '-samsung' : ''));
  },
  openSignIn: function openSignIn() {
    var self = this;
    var $content = $('<div id="modal-sign-in" class="card bg-gray" style="border: none;">' + '   <div class="card-body">' + '       <div class="title-sm text-center" style="padding: 10px 0;">' + '           <i class="fa fa-lock"></i>&nbsp;&nbsp;<b>Sign-in to your dashboard</b>' + '           <div class="alert alert-danger text-sm form-group" style="display: none;margin: 10px auto -10px;line-height: 22px;">Email / Order ID not found...<br />Please try again.</div>' + '       </div>' + '       <hr />' + '       <form id="form-sign-in" class="needs-validation" novalidate action="#">' + '           <div class="form-group" style="margin-top: 20px;">' + '               <label class="text-md">' + '                   Email address:' + '                </label>' + '                <input required id="input-email" type="email" class="input-email form-control form-control-sm text-sm" placeholder="Your@email.com...">' + '           </div>' + '           <div class="form-group" style="margin-top: 10px;margin-bottom: 20px;">' + '               <label for="" class="text-md">' + '                   Order ID:&nbsp;&nbsp;&nbsp;<a href="#" id="button-where" class="text-sm">where do I find this?</a>' + '                   <div class="help"></div>' + '               </label>' + '               <input required id="input-clientId" pattern="\\w\\w\\w\\w\\w\\w\\w" type="text" class="input-clientId form-control form-control-sm text-sm" placeholder="ab12cd3...">' + '           </div>' + '       </form>' + '   </div>' + '</div>');
    var $help = $('<div class="alert alert-warning alert-dismissible text-sm" style="margin-top: 10px;" role="alert">' + '   <div class="row">' + '       <div class="col-md-4 hidden-sm hidden-xs" style="padding-left: 0;">' + '           <img src="' + LSUtils.url() + '/cms/engine/assets/img/signin-help.png" style="max-height: 110px;" alt="sign-in help"/>' + '       </div>' + '       <div class="col-md-8" style="line-height: 18px;">' + '           You can find a reference to your order ID at the top of every email you received from us.' + '       </div>' + '   </div>' + '   <button type="button" class="close" data-dismiss="alert" aria-label="Close">' + '       <span aria-hidden="true">&times;</span>' + '   </button>' + '</div>');
    $('#button-where', $content).bind('click', function () {
      $('.help', $content).append($help);
      return false;
    });
    $('#form-sign-in', $content).on('submit', function (e) {
      $(this).addClass('was-validated');
      if (this.checkValidity()) {
        var $email = $('.input-email', $content);
        var $clientId = $('.input-clientId', $content);
        var btn = Ladda.create(document.querySelector('#button-sign-in-submit'));
        btn.start();
        $('.alert-danger', $content).hide();
        self.authenticate($email.val(), $clientId.val()).done(function () {
          $('#form-sign-in', $content).removeClass('was-validated');
          $email.val('');
          $clientId.val('');
          btn.stop();
          $('.alert-danger', $content).show();
        });
      }
      e.preventDefault();
      return false;
    });
    $('#container-header .active').removeClass('active');
    $('.mega-menu-container-showing').removeClass('mega-menu-container-showing');
    BootstrapDialog.show({
      title: 'Authentication',
      message: $content,
      buttons: [{
        id: 'button-sign-in-submit',
        label: '<i class="fa fa-lock"></i>&nbsp;&nbsp;Sign-in',
        cssClass: 'btn btn-success ladda-button',
        data: {
          style: 'expand-right'
        },
        action: function action(dialog) {
          $('#form-sign-in', $content).submit();
          return false;
        }
      }]
    });
  },
  authenticate: function authenticate(email, clientId) {
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + '/app/services/customer',
      data: {
        value: email,
        clientId: clientId
      },
      success: function success(json) {
        try {
          json = JSON.parse(json);
          if (json && json.data && (json.data.email === email || json.data.personalInfo && json.data.personalInfo.email === email)) window.location.href = LSUtils.url() + '/status/?clientId=' + clientId;else dfd.resolve();
        } catch (ex) {
          dfd.resolve();
        }
      }
    });
    return dfd.promise();
  }
};
$(function () {
  LSMegaMenu.initialize();
});
export { LSMegaMenu };